import apiRequestService from '@/commonProject/service/apiRequestService';

export default class AgreementRepository {
    /**
     * ユーザー同意規定取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getUserAgreementApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usrreg', requestBody, idToken);
        return result;
    }

    /**
     * 規定詳細取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @param {*} idToken
     * @returns result
     */
    async getAgreementDetailApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/regdtl', requestBody, idToken);
        return result;
    }
}
